import gql from 'graphql-tag';

export const createOrUpdateExclusionList = gql`
	mutation createOrUpdateExclusionList($exclusionList: ExclusionListInput!) {
		createOrUpdateExclusionList(exclusionList: $exclusionList) {
			id
			message
			exclusionList {
				id
				gameId
				airingId
				periods {
					items {
						endTime
						endpoint
						id
						playId
						shortText
						startTime
						title
					}
				}
			}
		}
	}
`;

export const deleteExclusionList = gql`
	mutation deleteExclusionList($id: ID!) {
		deleteExclusionList(id: $id) {
			id
		}
	}
`;
